<section class="Modal-Global Document-Viewer-Modal" [class.active]="visible">
  <div class="viewer-popup">
    <div class="content">
      <div class="Content-Top">
        <div class="Title-Area">
          <i class="fa-solid fa-file-lines"></i>
          <div>
            <h2>Vista Previa</h2>
            <h4 [title]="fileName">{{ fileName }}</h4>
          </div>
        </div>
        <div class="Actions-Area">
          <button (click)="download()" class="btn-preview-download" title="Descargar archivo">
            <i class="fa-solid fa-download"></i>
            <span>Descargar</span>
          </button>
          <button (click)="close()" class="Btn-Close-Header" title="Cerrar">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </div>

      <div class="Content-body viewer-body">
        <!-- Indicador de Carga -->
        <div class="viewer-loader" *ngIf="isLoading">
          <div class="spinner"></div>
          <p>Preparando vista previa...</p>
        </div>

        <!-- Visor de PDF Nativo (Solución Universal) -->
        <ng-container *ngIf="fileType === 'pdf'">
          <div class="pdf-native-wrapper">
            <pdf-viewer 
              *ngIf="pdfSrc"
              [src]="pdfSrc"
              [render-text]="true"
              [original-size]="false"
              [autoresize]="true"
              [show-all]="true"
              [fit-to-page]="true"
              class="pdf-viewer-canvas"
            ></pdf-viewer>
          </div>
        </ng-container>

        <!-- Visor de Imágenes -->
        <ng-container *ngIf="fileType === 'image'">
          <div class="image-viewer-container">
            <img *ngIf="safeImgUrl" [src]="safeImgUrl" [alt]="fileName" class="preview-image">
          </div>
        </ng-container>


        <!-- Visor de Texto Plano -->
        <ng-container *ngIf="fileType === 'text'">
          <div class="text-preview-container">
            <pre class="text-content-display">{{ textContent }}</pre>
          </div>
        </ng-container>

        <!-- Otros archivos / No soportados -->
        <ng-container *ngIf="fileType === 'other'">
           <div class="no-preview-available">
            <i class="fa-solid fa-file-circle-question"></i>
            <p>Este tipo de archivo no soporta vista previa directa.</p>
            <span>Usa el botón de descarga para ver el contenido.</span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
